
let currentlyOpenTip = null;

$(function() {
    


$('.HSAtip').on('click', function(event) {
    event.stopPropagation(); // Prevent the event from bubbling up and closing the tooltip

    const $this = $(this).children().last();

    // If the clicked element's tooltip is already open, close it
    if (currentlyOpenTip && currentlyOpenTip.is($this)) {
        $this.tipso('hide');
        currentlyOpenTip = null;
        return;
    }

    // If there is another open tooltip, hide it
    if (currentlyOpenTip) {
        currentlyOpenTip.tipso('hide');
    }

    // Initialize the tooltip (only if it's not already initialized)
    if (!$this.data('tipso-init')) {
            $this.tipso({
            content: $(this).attr("title"), // Tooltip content
         
             width:350,
              maxWidth:500,
              speed: 300, // Animation speed
            background: '#000', // Background color
            color: '#fff', // Text color
            borderWidth: 2, // Border width
            delay: 0, // Delay before showing the tooltip
            trigger: 'manual', // Manual control over when the tooltip shows/hides
            useTitle: false, // Don't show the title attribute by default on hover
            hideDelay: 0, // No delay in hiding (optional)
            hideOnClickOutside: false, // Disable hiding on outside click
            hideOnEscape: false, // Disable hiding on escape key
          onHide: function() {
      // 当tooltip隐藏时，解绑鼠标移出事件
         
     $this.off('mouseleave');
    },
 onShow: function() {
      // 当tooltip显示时，绑定鼠标移出事件
      $this.on('mouseleave', function() {
         $this.tipso('hide');
      });
    }
        });
        $this.data('tipso-init', true); // Mark as initialized
    }

    // Show the tooltip
    $this.tipso('show');
    currentlyOpenTip = $this; // Set the current tooltip as the open one
});
});

$(document).on('click', function(event) {
    if (currentlyOpenTip && !$(event.target).closest('.HSAtip').length) {
        currentlyOpenTip.tipso('hide');
        currentlyOpenTip = null;
    }
});

/*
$(document).on('click', function(e) {

  if (!$('.HSAtip').is(e.target) && $('.HSAtip').has(e.target).length === 0) {

    $('.HSAtip').tipso('hide');
  }
});*/